import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { useContext } from "react";
import { setSnackbar } from "../../../util/state/globalAction";
import { snackbarTypes } from "../../../util/state/globalVariables";
import { useTranslation } from "react-i18next";
import { useState, useEffect} from 'react';

const fetchUserList = async (email: string, status: string | null  = null, conventionCode: string | null = null) => {
  const response = await axios.get("/corporateidp/user/list", {
    params: {
      mail: email || null,
      status,
      conventionCode: conventionCode || null,
    },
  });

  if (response.status !== 200) {
    throw new Error("Error fetching user list");
  }
  return response.data;
};

export const useUserList = (queryKey:any) => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  const {t} = useTranslation();
  const [userData, setUserData] = useState<undefined | []>(undefined);

  const query = useQuery(queryKey, () => fetchUserList(queryKey[1], queryKey[2], queryKey[3]), {
    enabled: true, 
    retry: false, 
    onSuccess: (data) => {
      setUserData(data || []);
    },
    select: (data) => data || [], 
    onError: (error) => {
      setUserData([]);
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t('error.tryLater'),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
    },
    
  });
    
  return { ...query, data: userData };

};

const toggleUserStatus = async ({ userCode, status }:any) => {
  const response = await axios.post(`/corporateidp/user/${status ? "active" : "deactive"}`, `${userCode}`, {
    headers: {
      "Content-Type": "application/json",
    }
  });

  if (response.status !== 200) {
    throw new Error("Error toggling user status");
  }
  return response.data;
};

export const useToggleUserStatus = () => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  const {t} = useTranslation();

  return useMutation(toggleUserStatus, {
    retry: false, // Don't retry on failure
    onError: (error) => {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t('error.tryLater'),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
    },
  });
};


const resetPassword = async (userCode: string) => {
  const response = await axios.post(`/corporateidp/password/reset`, `${userCode}`, {
    headers: {
      "Content-Type": "application/json",
    }
  });

  if (response.status !== 200) {
    throw new Error("Error resetting user password");
  }
  return response.data;
};

export const useResetUserPassword = () => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { t } = useTranslation();

  return useMutation(resetPassword, {
    retry: false,
    onError: (error) => {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t('error.tryLater'),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
    },
    onSuccess: (data) => {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t('success.resetPassword'),
            type: snackbarTypes.success,
            show: true,
            autoClose: true,
          },
        },
      });
    }
  });
};
